import {
  AccountPaymentMethodAddApiElementContentModelContentType,
  AccountPaymentMethodsApiElementContentModelContentType,
  ActivityDetailApiElementContentModelContentType,
  ActivityListApiElementContentModelContentType,
  AddressBookApiElementContentModelContentType,
  ApiBlockItemModel,
  AssistanceElementContentModelContentType,
  BookingDetailAPIElementContentModelContentType,
  BookingListAPIElementContentModelContentType,
  ByCategoryBrandContentElementContentModelContentType,
  ByCategoryCategoryContentElementContentModelContentType,
  ByCategoryCollectionContentElementContentModelContentType,
  ContactPrivacySettingsAPIElementContentModelContentType,
  FavoritesApiElementContentModelContentType,
  FormBlockElementContentModelContentType,
  HomePageHeroBannerElementContentModelContentType,
  HomePageHighlightsForYouElementContentModelContentType,
  HomePageUpcomingBookingsElementContentModelContentType,
  HomePageWhatsOnElementContentModelContentType,
  HomePageYourMemberCardElementContentModelContentType,
  IconLinksElementContentModelContentType,
  InterestsApiElementContentModelContentType,
  LinksNavigationElementContentModelContentType,
  ManageNotificationsApiElementContentModelContentType,
  MembershipElementContentModelContentType,
  PersonalInformationApiElementContentModelContentType,
  RateThisAppElementContentModelContentType,
  RteBlockElementContentModelContentType,
  ShopBrandsListApiElementContentModelContentType,
  ShopCollectionListApiElementContentModelContentType,
  ShopProductListApiElementContentModelContentType,
  ShopSearchApiElementContentModelContentType,
  ShopSubCategoriesListApiElementContentModelContentType,
  TextBlockElementContentModelContentType,
  TitleRteBlockElementContentModelContentType,
  VerticalSpacingElementContentModelContentType,
  YourMemberCardElementContentModelContentType,
} from '@/services/platform/api/model';
import React, { Suspense } from 'react';

import { TextBlock } from '../textBlock';
import { VerticalSpacing } from '../verticalSpacing';
import { FormBlock } from '../formBlock';
import { AppContext } from '@/lib/core/types';

// Home modules
import { HomePageHeroBanner } from '../heroBanner';
import { YourMemberCard } from '../yourMemberCard';
import { HomePageUpcomingBookings } from '../upcomingBookings';
import { RteBlock } from '../rteBlock';
import { HomePageHighlightsForYou } from '../highlightsForYou';
import { HomePageWhatsOn } from '../whatsOn';
import { BookingListAPI } from '../bookingListAPI';
import { BookingDetailAPI } from '../bookingDetailAPI';
import { IconLinks } from '../iconLinks';
import { LinksNavigation } from '../linksNavigation';
import { PersonalInformationApi } from '../personalInformationApi';
import { AddressBookApi } from '../addressBookApi';
import { AccountPaymentMethodsApi } from '../accountPaymentMethodsApi';
import { AccountPaymentMethodAddApi } from '../accountPaymentMethodAddApi';
import { InterestsApi } from '../interestsApi';
import { FavoritesApi } from '../favoritesApi';
import { ContactPrivacySettingsApi } from '../contactPrivacySettingsApi';
import { TitleRteBlock } from '../titleRteBlock';
import { ManageNotificationsApi } from '../manageNotificationsApi';
import { Membership } from '../membership';
import { Assistance } from '../assistance';
import { RateThisApp } from '../rateThisApp';
import { ActivityListAPI } from '../activityListApi';
import { ByCategoryCollectionContent } from '../byCategoryCollectionContent';
import { ByCategoryCategoryContent } from '../byCategoryCategoryContent';
import { ByCategoryBrandContent } from '../byCategoryBrandContent';
import { ShopSubCategoriesListApi } from '../shopSubCategoriesListApi';
import { ShopCollectionListApi } from '../shopCollectionListApi';
import { ShopBrandsListApi } from '../shopBrandsListApi';
import { ShopProductListApi } from '../shopProductListApi';
import { ShopSearchApi } from '../shopSearchApi';
import { ActivityDetailAPI } from '../activityDetailApi';

interface ModuleProps {
  item: ApiBlockItemModel;
  index: number;
  context?: AppContext;
  extraProps?: Record<string, any>;
}

const components = [
  { contentType: TextBlockElementContentModelContentType.textBlock, component: TextBlock },
  { contentType: VerticalSpacingElementContentModelContentType.verticalSpacing, component: VerticalSpacing },
  { contentType: FormBlockElementContentModelContentType.formBlock, component: FormBlock },

  // jnCquoi app modules

  {
    contentType: HomePageHeroBannerElementContentModelContentType.homePageHeroBanner,
    component: HomePageHeroBanner,
  },
  {
    contentType: HomePageYourMemberCardElementContentModelContentType.homePageYourMemberCard,
    component: YourMemberCard,
  },
  {
    contentType: YourMemberCardElementContentModelContentType.yourMemberCard,
    component: YourMemberCard,
  },
  {
    contentType: HomePageUpcomingBookingsElementContentModelContentType.homePageUpcomingBookings,
    component: HomePageUpcomingBookings,
  },
  {
    contentType: RteBlockElementContentModelContentType.rteBlock,
    component: RteBlock,
  },
  {
    contentType: HomePageHighlightsForYouElementContentModelContentType.homePageHighlightsForYou,
    component: HomePageHighlightsForYou,
  },
  {
    contentType: HomePageWhatsOnElementContentModelContentType.homePageWhatsOn,
    component: HomePageWhatsOn,
  },
  {
    contentType: BookingListAPIElementContentModelContentType.bookingListAPI,
    component: BookingListAPI,
  },
  {
    contentType: BookingDetailAPIElementContentModelContentType.bookingDetailAPI,
    component: BookingDetailAPI,
  },
  {
    contentType: IconLinksElementContentModelContentType.iconLinks,
    component: IconLinks,
  },
  {
    contentType: LinksNavigationElementContentModelContentType.linksNavigation,
    component: LinksNavigation,
  },
  {
    contentType: PersonalInformationApiElementContentModelContentType.personalInformationApi,
    component: PersonalInformationApi,
  },
  {
    contentType: AddressBookApiElementContentModelContentType.addressBookApi,
    component: AddressBookApi,
  },
  {
    contentType: AccountPaymentMethodsApiElementContentModelContentType.accountPaymentMethodsApi,
    component: AccountPaymentMethodsApi,
  },
  {
    contentType: AccountPaymentMethodAddApiElementContentModelContentType.accountPaymentMethodAddApi,
    component: AccountPaymentMethodAddApi,
  },
  {
    contentType: InterestsApiElementContentModelContentType.interestsApi,
    component: InterestsApi,
  },
  {
    contentType: FavoritesApiElementContentModelContentType.favoritesApi,
    component: FavoritesApi,
  },
  {
    contentType: ContactPrivacySettingsAPIElementContentModelContentType.contactPrivacySettingsAPI,
    component: ContactPrivacySettingsApi,
  },
  {
    contentType: ManageNotificationsApiElementContentModelContentType.manageNotificationsApi,
    component: ManageNotificationsApi,
  },
  {
    contentType: MembershipElementContentModelContentType.membership,
    component: Membership,
  },
  {
    contentType: AssistanceElementContentModelContentType.assistance,
    component: Assistance,
  },
  {
    contentType: RateThisAppElementContentModelContentType.rateThisApp,
    component: RateThisApp,
  },
  {
    contentType: ActivityListApiElementContentModelContentType.activityListApi,
    component: ActivityListAPI,
  },
  {
    contentType: ActivityDetailApiElementContentModelContentType.activityDetailApi,
    component: ActivityDetailAPI,
  },
  {
    contentType: ByCategoryCollectionContentElementContentModelContentType.byCategoryCollectionContent,
    component: ByCategoryCollectionContent,
  },
  {
    contentType: ByCategoryCategoryContentElementContentModelContentType.byCategoryCategoryContent,
    component: ByCategoryCategoryContent,
  },
  {
    contentType: ByCategoryBrandContentElementContentModelContentType.byCategoryBrandContent,
    component: ByCategoryBrandContent,
  },
  {
    contentType: ShopSubCategoriesListApiElementContentModelContentType.shopSubCategoriesListApi,
    component: ShopSubCategoriesListApi,
  },
  {
    contentType: ShopCollectionListApiElementContentModelContentType.shopCollectionListApi,
    component: ShopCollectionListApi,
  },
  {
    contentType: ShopBrandsListApiElementContentModelContentType.shopBrandsListApi,
    component: ShopBrandsListApi,
  },
  {
    contentType: ShopProductListApiElementContentModelContentType.shopProductListApi,
    component: ShopProductListApi,
  },
  {
    contentType: ShopSearchApiElementContentModelContentType.shopSearchApi,
    component: ShopSearchApi,
  },
  {
    contentType: TitleRteBlockElementContentModelContentType.titleRteBlock,
    component: TitleRteBlock,
  },
];

export function Module({ item, index, context, extraProps = {} }: ModuleProps) {
  const matchedComponent = components.find(c => c.contentType === item.content?.contentType);

  if (matchedComponent === undefined) {
    return null;
  }

  const DynamicComponent = matchedComponent.component;

  return (
    <Suspense fallback={null}>
      <DynamicComponent
        index={index}
        content={item.content}
        settings={item.settings}
        context={context}
        {...extraProps}
      />
    </Suspense>
  );
}
